// @ts-ignore

import React from "react";
import {Flags} from "../Flags/Flags";

const subsidiarySelectItems = subsidiaries =>
    subsidiaries.map(subsidiary => ({
        label: (
            <div className="select-country">
                {subsidiary.id !== 10 && (
                    <Flags
                        country={subsidiary.country.code.toLowerCase()}
                        width="18px"
                        height="18px"
                    />
                )}
                {subsidiary.id === 10 && (
                    <img
                        src="/ntt.png"
                        className="dingo-icon"
                        width="18px"
                        height="18px"
                    />
                )}
                <span>{subsidiary.description}</span>
            </div>
        ),
        value: subsidiary.id
    }));

const subsidiaryIcon = sub =>
    (
        <div style={{display: 'contents'}} className={'sub-icon'}>
            {sub.id !== 2 && sub.id !== 10 && (
                <Flags
                    country={sub.country.code.toLowerCase()}
                    width="18px"
                    height="18px"
                />
            )}
            {sub.id === 2 && (
                <img
                    src="/dingo.png"
                    className="dingo-icon"
                    width="18px"
                    height="18px"
                />
            )}
            {sub.id === 10 && (
                <img
                    src="/ntt.png"
                    className="dingo-icon"
                    width="18px"
                    height="18px"
                />
            )}
        </div>
    )

export const SubsidiaryUtils = {
    subsidiarySelectItems,
    subsidiaryIcon
};
